export default function NoNotesFound() {
  return(
    <div className="flex justify-center w-full bg-grey-900 m-4 rounded-md text-left px-2">
      <h3 className="text- text-fpx-red">No Notes Found</h3>
    </div>
  )
}